import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { DataViewKey } from '@keepeek/commons';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import ListDataView from '../Dataview/Modes/ListDataView/index.js';
import { useTitleFieldInColumnsResolver } from '../Dataview/Modes/ListDataView/utils.js';
import KButton from '../KButtons/index.js';
import StyledKReportWidget from './index.styled.js';

var KReportWidget = function (_a) {
    var backgroundColor = _a.backgroundColor, onSeeAllReportClick = _a.onSeeAllReportClick, seeAllButtonLabel = _a.seeAllButtonLabel, filters = _a.filters, goToPageWithBackContext = _a.goToPageWithBackContext, KIcon = _a.KIcon, _b = _a.testId, testId = _b === void 0 ? "KReportWidget" : _b, className = _a.className, id = _a.id, sx = _a.sx, rest = __rest(_a, ["backgroundColor", "onSeeAllReportClick", "seeAllButtonLabel", "filters", "goToPageWithBackContext", "KIcon", "testId", "className", "id", "sx"]);
    var t = useTranslation("refront-components").t;
    var columns = useTitleFieldInColumnsResolver({
        KIcon: KIcon,
        showLinks: false,
        showTags: false,
        dataViewKey: DataViewKey.REPORT
    });
    return (React__default.createElement(StyledKReportWidget, __assign({ backgroundColor: backgroundColor, id: id, "data-testid": testId, className: clsx("KReportWidget", className), sx: sx }, rest),
        React__default.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "flex-end", padding: ".5rem", style: { gap: "1rem" } }, onSeeAllReportClick && (React__default.createElement(KButton, { variant: "text", size: "small", onClick: onSeeAllReportClick },
            React__default.createElement(KIcon, { fontSize: "small", className: "fa-solid fa-eye fa-lg" }),
            "\u00A0",
            seeAllButtonLabel))),
        React__default.createElement(ListDataView, { dataViewKey: DataViewKey.REPORT, filters: filters, columns: columns, KIcon: KIcon, shareTokenDownloadAuthorized: false, goToPageWithBackContext: goToPageWithBackContext, title: t("components.widget.report.table.title"), summary: t("components.widget.report.table.summary") })));
};

export { KReportWidget as default };
//# sourceMappingURL=index.js.map
